
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'not-found',
  setup() {
    return {}
  },
  components: {}
})
